// Chakra imports
import { Portal, Box, useDisclosure } from "@chakra-ui/react";
import Footer from "components/footer/FooterAdmin";
// Layout components
import Navbar from "components/navbar/NavbarAdmin";
import Sidebar from "components/Sidebar/Sidebar";
import { SidebarContext } from "contexts/SidebarContext";
import useGeneral from "hooks/use-general";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Redirect, Route, Switch } from "react-router-dom";
import routes from "routes";
import auth from "services/auth";
import JobsPage from "views/Settigns/JobsPage";
import { appConfig } from "env-config";
import { useAuth0 } from "@auth0/auth0-react";
import { decodeToken } from "react-jwt";

// Custom Chakra theme
export default function Dashboard(props: { [x: string]: any }) {
  const { ...rest } = props;
  const [maintence, setMaintence] = useState(false);
  const { logout } = useAuth0();
  const clientId = appConfig.REACT_APP_AUTH0_CLIENT_ID;
  const audience = appConfig.REACT_APP_AUTH0_AUDIENCE;
  const userInfos = JSON.parse(
    localStorage.getItem(
      `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
    )
  );
  // states and functions
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  // functions for changing the states from components
  const getRoute = () => {
    return window.location.pathname !== "/admin/full-screen-maps";
  };
  const { sideBarCollapse } = useGeneral();

  const getActiveRoute = (routes: RoutesType[]): string => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].name;
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes: RoutesType[]): boolean => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };
  const getActiveNavbarText = (routes: RoutesType[]): string | boolean => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].name;
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((route: RoutesType, key: any) => {
      if (route.layout === "/admin") {
        return (
          <Route
            path={route.layout + route.path}
            component={route.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  useEffect(() => {
    const APP_VERSION = appConfig.REACT_APP_CURRENT_VERSION;

    if (
      typeof localStorage.APP_VERSION === "undefined" ||
      localStorage.APP_VERSION === null
    ) {
      localStorage.clear();
      localStorage.setItem("APP_VERSION", APP_VERSION);
      logout({ returnTo: window.location.origin });
    }

    if (localStorage.APP_VERSION !== APP_VERSION) {
      localStorage.setItem("APP_VERSION", APP_VERSION);
      logout({ returnTo: window.location.origin });
    }
    auth
      .getDailyProcessLog()
      .then(({ data: { data } }) => {
        setMaintence(false);
      })
      .catch((error) => {
        if (error.response?.status !== 400) {
          setMaintence(false);
        }
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  document.documentElement.dir = "ltr";
  const { onOpen } = useDisclosure();
  const tokenData: any = userInfos?.body.access_token
    ? decodeToken(userInfos.body.access_token)
    : null;

  const routesFilter = routes.filter((item) => {
    let role = "All";
    if (tokenData && tokenData.profile) {
      role = tokenData.profile;
    }
    return !item.roles || item.roles.includes(role);
  });
  return (
    <>
      {maintence ? (
        <JobsPage />
      ) : (
        <>
          <Helmet>
            <title>{getActiveRoute(routesFilter)} - Agendamento</title>
          </Helmet>
          <Box>
            <SidebarContext.Provider
              value={{
                toggleSidebar,
                setToggleSidebar,
              }}
            >
              <Sidebar routes={routesFilter} display="none" {...rest} />
              <Box
                float="right"
                minHeight="100vh"
                height="100%"
                overflow="auto"
                position="relative"
                maxHeight="100%"
                w={
                  sideBarCollapse
                    ? { base: "100%", xl: "calc( 100% - 120px )" }
                    : { base: "100%", xl: "calc( 100% - 290px )" }
                }
                maxWidth={
                  sideBarCollapse
                    ? { base: "100%", xl: "calc( 100% - 120px )" }
                    : { base: "100%", xl: "calc( 100% - 290px )" }
                }
                transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
                transitionDuration=".2s, .2s, .35s"
                transitionProperty="top, bottom, width"
                transitionTimingFunction="linear, linear, ease"
              >
                <Portal>
                  <Box>
                    <Navbar
                      onOpen={onOpen}
                      logoText={"Horizon UI Dashboard PRO"}
                      brandText={getActiveRoute(routesFilter)}
                      secondary={getActiveNavbar(routesFilter)}
                      message={getActiveNavbarText(routesFilter)}
                      fixed={fixed}
                      {...rest}
                    />
                  </Box>
                </Portal>

                {getRoute() ? (
                  <Box
                    mx="auto"
                    p={{ base: "20px", md: "30px" }}
                    pe="2px"
                    minH="8vh"
                    pt="5px"
                  >
                    <Switch>
                      {getRoutes(routesFilter)}
                      <Redirect from="/" to="/admin/home" />
                    </Switch>
                  </Box>
                ) : null}
                <Box>
                  <Footer />
                </Box>
              </Box>
            </SidebarContext.Provider>
          </Box>
        </>
      )}
    </>
  );
}
